<template>
  <b-tabs content-class="mt-4" nav-wrapper-class="switching-tabs">
    <b-tab title="My Created Screening (0)" active>
      <!-- SHOW THIS DIV WHEN USER HAS 0 CREATED SCREENING -->
      <div class="d-none">
        <p class="mb-4">
          Aw shucks! You don’t have any new event(s) that you’ve created
          <br />Go ahead make one! The force is strong with you.
        </p>

        <button class="btn-gogo btn-cos">Create your own screening</button>
      </div>

      <!-- SHOW THIS DIV WHEN USER HAS CREATED SCREENING  -->
      <div>
        <div class="cs-container">
          <div class="d-flex flex-wrap">
            <div class="w-100">
              <div class="d-flex flex-wrap">
                <div class="col-3 col-md-2 col-xl-1 px-0">
                  <img src="@/assets/img/screening.png" class="img-fluid rounded" alt />
                </div>
                <div class="col-9 col-md-10 col-xl-11 d-flex flex-wrap pr-0">
                  <!-- <div class="d-flex flex-wrap"> -->
                  <div class="col-md-4 pl-md-0">
                    <div class="font-weight-bold">The Gifted Hands</div>
                    <div class="small">
                      <span>Korean</span>
                      <span>|</span>
                      <span>120 Min</span>
                      <span>2013</span>
                      <span>Kwn Ha-youg</span>
                    </div>
                  </div>
                  <div class="col-md-4 pl-md-0">
                    <div class="text-primary">Capitol Theater</div>
                    <div>Sep 4 , 2018 | 3:30 PM</div>
                  </div>
                  <div class="col-md-4 text-md-right">
                    <button class="btn-gogo mw-230 ml-md-auto d-none d-md-block">Share with friends</button>
                    <div class="mt-md-2">
                      <span class="small">
                        <router-link to="#" class="text-dark">Resend Email</router-link>
                      </span>
                      <span>|</span>
                      <span class="small">
                        <router-link to="#" class="text-dark">Resend M-ticket</router-link>
                      </span>
                    </div>
                  </div>
                  <!-- </div> -->
                  <div class="col-12 d-none d-md-block">
                    <div class="row">
                      <div class="col-6 col-lg-8 col-xl-5 d-none d-md-block pl-md-0">
                        <div class="d-flex justify-content-between lh-1">
                          <div>NOT CONFIRMED</div>
                          <div class="small">15 OUT OF 85 SEATS SOLD</div>
                        </div>
                        <b-progress
                          height="22px"
                          :value="50"
                          :variant="variant"
                          show-progress
                          class="my-2"
                        ></b-progress>
                        <div class="tiny text-right">Only 10 Seats Required</div>
                      </div>
                      <div class="col-xl-7 d-flex align-items-center justify-content-end">
                        <div class="small">
                          <router-link to="#" class="text-primary">Edit</router-link>
                          <span>|</span>
                          <router-link to="#" class="text-primary">Delete</router-link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- MOBILE STATUS BAR -->
                <div class="w-100 d-md-none mt-2">
                  <div class="d-flex justify-content-between">
                    <div>NOT CONFIRMED</div>
                    <div class="small">15 OUT OF 85 SEATS SOLD</div>
                  </div>
                  <b-progress
                    height="18px"
                    :value="50"
                    :variant="variant"
                    show-progress
                    class="my-1"
                  ></b-progress>

                  <div class="d-flex justify-content-between align-items-center">
                    <div class="small">Only 10 Seats Required</div>
                    <div>
                      <router-link to="#" class="text-primary small">Edit</router-link>
                      <span>|</span>
                      <router-link to="#" class="text-primary small">Delete</router-link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- CREATE ANOTHER SCREEING BUTTON -->
      <div class="cas-container">
        <router-link to="#">
          <svg
            width="59"
            height="59"
            viewBox="0 0 59 59"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M29.5 59C45.7924 59 59 45.7924 59 29.5C59 13.2076 45.7924 0 29.5 0C13.2076 0 0 13.2076 0 29.5C0 45.7924 13.2076 59 29.5 59Z"
              fill="#2B2D42"
            />
            <path
              d="M20.5 25H17.5C15.0147 25 13 27.0147 13 29.5C13 31.9853 15.0147 34 17.5 34H20.5C22.9853 34 25 36.0147 25 38.5V41.5C25 43.9853 27.0147 46 29.5 46C31.9853 46 34 43.9853 34 41.5V38.5C34 36.0147 36.0147 34 38.5 34H41.5C43.9853 34 46 31.9853 46 29.5C46 27.0147 43.9853 25 41.5 25H38.5C36.0147 25 34 22.9853 34 20.5V17.5C34 15.0147 31.9853 13 29.5 13C27.0147 13 25 15.0147 25 17.5V20.5C25 22.9853 22.9853 25 20.5 25Z"
              fill="#fff"
            />
          </svg>
          <div class="mt-2 font-weight-bold text-dark">Created Another Screening</div>
        </router-link>
      </div>
    </b-tab>

    <b-tab title="My Booked Screening (0)">
      <p>I'm the second tab content</p>
    </b-tab>
  </b-tabs>
</template>

<script>
export default {
  data() {
    return {
      value: 75,
      variant: "danger"
    };
  }
};
</script>

<style scoped>
.lh-1 {
  line-height: 1;
}

.cs-container .progress,
.cs-container .progress-bar {
  border-radius: 10px;
}

.tiny {
  font-size: 10px;
}

.mw-230 {
  max-width: 230px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/mySpecialScreening.vue